export default {
  proposalGeneration: {
    generateProposal: 'Download',
    form: {
      totalPriceInPoints: 'Total Points',
      company: 'Customer Name',
    },
  },
  productList: {
    priceFilterLabel: 'Filter Items by Points',
  },
  productDetails: {
    addToSOW: 'Add to Proposal',
    addedToSOW: 'Remove from Proposal',
    addedToOrder: 'Remove from Proposal',
    rows: {
      documents: {
        downloadSelected: 'Download selected items',
      },
    },
  },
  proposals: {
    columns: {
      clientName: 'Client Name / Proposal Name',
    },
  },
}
